import { useQuery, useQueryClient } from "react-query";

import { APICore } from "./api/apiCore";
import { unwrapItem } from "../components/inventory/unwrap";

// =============================================================================
// Pending-work counts for the KYB & Compliance sidebar badges (applications waiting
// for a decision, compliance documents waiting for review, services waiting to be
// switched on). One call for the whole section; the server leaves out the counts the
// user has no permission for.
// =============================================================================

export const COMPLIANCE_COUNTS_KEY = "compliance-counts";

export interface ComplianceCounts {
  applications?: number;
  documents?: number;
  companyDocuments?: number;
  inventoryDocuments?: number;
  /** Services suppliers have asked to switch on, still awaiting a decision. */
  activationRequests?: number;
}

export const useComplianceCounts = (): ComplianceCounts => {
  const api = new APICore();
  const { data } = useQuery(COMPLIANCE_COUNTS_KEY, () => api.get("/api/compliance/counts", {}), {
    enabled: api.isUserAuthenticated(),
    // A queue someone else is working drains while this tab is open.
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
    // A failed count just means no badge.
    retry: false,
  });
  return unwrapItem<ComplianceCounts>(data) ?? {};
};

/** Call after approving / rejecting so the badges drop immediately. */
export const useRefreshComplianceCounts = () => {
  const qc = useQueryClient();
  return () => qc.invalidateQueries(COMPLIANCE_COUNTS_KEY);
};
